export default __webpack_public_path__ + "static/media/pipe-mob.352150ec.webp";